import { render, staticRenderFns } from "./dynamic-table.vue?vue&type=template&id=47a198da"
import script from "./dynamic-table.vue?vue&type=script&lang=js"
export * from "./dynamic-table.vue?vue&type=script&lang=js"
import style0 from "./dynamic-table.vue?vue&type=style&index=0&id=47a198da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports